import { push } from 'react-router-redux';
import { showErrorMessage } from 'actions/messages';
import { serviceProvidersApi } from 'services/api/service-providers-api';
import { formatPhoneNumber } from 'services/utils/text-util';

import {
  SET_SERVICE_PROVIDER_DROPDOWN,
  SET_CURRENT_PAGE,
  SET_SERVICE_PROVIDER_DATA,
  SET_TOTAL,
  SET_PAGE_SIZE,
  SET_NAME_TO_SEARCH,
  SET_SERVICE_PROVIDER_USER_DATA,
  SET_COMPANY_DATA,
  SET_CURRENT_USER_COMPANY,
  SERVICE_PROVIDERS_INVITE_USER_FORM_LOAD,
  SERVICE_PROVIDERS_INVITE_USER_MODAL_SHOW,
  SERVICE_PROVIDERS_INVITE_USER_ID_SET,
  SERVICE_PROVIDERS_SHOW_CONFIRMATION_MODAL,
  SERVICE_PROVIDERS_CLEAR_FILTERS,
} from 'components/admin/service-providers/store/action-types';

const baseRoutePath = '/admin/service-providers';
const baseRoutePathTeam = '/admin/team';

export function setServiceProviderDropdown(project) {
  return {
    type: SET_SERVICE_PROVIDER_DROPDOWN,
    payload: project,
  };
}

export function setServiceProviderData(project) {
  return {
    type: SET_SERVICE_PROVIDER_DATA,
    payload: project,
  };
}

export function setServiceProviderUserData(userData) {
  return {
    type: SET_SERVICE_PROVIDER_USER_DATA,
    payload: userData,
  };
}

export function setCompanyData(company) {
  return {
    type: SET_COMPANY_DATA,
    payload: company,
  };
}

export function setCurrentUserCompany(company) {
  return {
    type: SET_CURRENT_USER_COMPANY,
    payload: company,
  };
}

export function loadServiceProviders(type, name, page) {
  return (dispatch) => {
    return serviceProvidersApi
      .getServiceProviders(type, name, page, false)
      .then((response) => {
        if (response.ok) {
          dispatch(setServiceProviderData(response.serviceProviders));
          dispatch(setTotal(response.total));
          dispatch(setPageSize(response.pageSize));
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}

export function loadServiceProvidersUser(type, serviceProviderId) {
  return (dispatch) => {
    return serviceProvidersApi
      .getServiceProviderUsers(type, serviceProviderId, false)
      .then((response) => {
        if (response.ok) {
          dispatch(setServiceProviderUserData(response.users));
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}

export function loadServiceProviderById(type, serviceProviderId) {
  return (dispatch) => {
    return serviceProvidersApi
      .showServiceProviderById(type, serviceProviderId, false)
      .then((response) => {
        if (response.ok) {
          response.serviceProvider.type = type;
          dispatch(setCompanyData(response.serviceProvider));
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}

export function loadCurrentUserCompany(type, id) {
  return (dispatch) => {
    return serviceProvidersApi
      .showServiceProviderById(type, id, false)
      .then((response) => {
        if (response.ok) {
          dispatch(setCurrentUserCompany(response.serviceProvider));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function updateCurrentUserCompany(type, id, values) {
  return (dispatch) => {
    return serviceProvidersApi
      .updateServiceProvider(type, id, values)
      .then((response) => {
        if (response.ok) {
          dispatch(setCurrentUserCompany(response.serviceProvider));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function updateServiceProvider(type, id, values) {
  return (dispatch) => {
    return serviceProvidersApi
      .updateServiceProvider(type, id, values)
      .then((response) => {
        if (response.ok) {
          dispatch(setCompanyData(response.serviceProvider));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function createServiceProvider(type, values) {
  return (dispatch) => {
    return serviceProvidersApi
      .createServiceProvider(type, values)
      .then((response) => {
        if (response.ok) {
          dispatch(setCompanyData(response.serviceProvider));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function changePage(page) {
  return {
    type: SET_CURRENT_PAGE,
    payload: page,
  };
}

export function setTotal(total) {
  return {
    type: SET_TOTAL,
    payload: total,
  };
}

export function setNameToSearch(name) {
  return {
    type: SET_NAME_TO_SEARCH,
    payload: name,
  };
}

export function setPageSize(pageSize) {
  return {
    type: SET_PAGE_SIZE,
    payload: pageSize,
  };
}

export function loadUserForm(user) {
  return (dispatch) => {
    const form = {
      id: user.id,
      accountableId: user.accountable_id,
      type: user.accountable_type,
      buildingsId: user.building_ids,
      firstName: user.first_name,
      lastName: user.last_name,
      email: user.email,
      phoneNumber: user.phone_number
        ? formatPhoneNumber(user.phone_number)
        : '',
      phoneExt: user.phone_ext ? user.phone_ext : '',
      rolesId: user.roles ? user.roles.map((role) => role.id) : null,
      title: user.title ? user.title : '',
    };

    dispatch({
      type: SERVICE_PROVIDERS_INVITE_USER_FORM_LOAD,
      payload: form,
    });
  };
}

export function clearUserData() {
  return {
    type: SERVICE_PROVIDERS_INVITE_USER_FORM_LOAD,
  };
}

export function clearFilters() {
  return {
    type: SERVICE_PROVIDERS_CLEAR_FILTERS,
  };
}

export function setShowEditUserModal(open) {
  return {
    type: SERVICE_PROVIDERS_INVITE_USER_MODAL_SHOW,
    payload: open,
  };
}

export function setShowConfirmationModal(open) {
  return {
    type: SERVICE_PROVIDERS_SHOW_CONFIRMATION_MODAL,
    payload: open,
  };
}

export function setCurrentUserId(userId) {
  return {
    type: SERVICE_PROVIDERS_INVITE_USER_ID_SET,
    payload: userId,
  };
}

export function editUser(values, type, serviceProviderId) {
  return (dispatch) => {
    return serviceProvidersApi.editUser(values).then((response) => {
      if (!response.ok) {
        dispatch(showErrorMessage(response.errors));
      } else {
        dispatch(setShowEditUserModal(false));
        dispatch(loadServiceProvidersUser(type, serviceProviderId));
      }

      return response;
    });
  };
}

export function inviteUser(values, type, serviceProviderId) {
  return (dispatch) => {
    return serviceProvidersApi
      .inviteUser(type, serviceProviderId, values)
      .then((response) => {
        if (!response.ok) {
          dispatch(showErrorMessage(response.errors));
        } else {
          dispatch(setShowEditUserModal(false));
          dispatch(loadServiceProvidersUser(type, serviceProviderId));
        }

        return response;
      });
  };
}

export function deleteUser(values, type, serviceProviderId) {
  return (dispatch) => {
    return serviceProvidersApi.deleteUser(values).then((response) => {
      if (!response.ok) {
        dispatch(showErrorMessage(response.errors));
      } else {
        dispatch(setShowEditUserModal(false));
        dispatch(loadServiceProvidersUser(type, serviceProviderId));
      }

      return response;
    });
  };
}

export function goToServiceProviders() {
  return (dispatch) => {
    dispatch(push(baseRoutePath));
  };
}

export function goToNewServiceProvider(type) {
  return (dispatch) => {
    dispatch(push(`${baseRoutePath}/${type}/new`));
  };
}

export function goToServiceProviderDetails(type, id) {
  const team = window.location.pathname.includes(baseRoutePathTeam);
  return (dispatch) => {
    if (team) {
      dispatch(push(baseRoutePathTeam));
    } else {
      dispatch(push(`${baseRoutePath}/${type}/${id}`));
    }
  };
}

export function goToEditServiceProvider(type, id) {
  const team = window.location.pathname.includes(baseRoutePathTeam);
  return (dispatch) => {
    if (team) {
      dispatch(push(`${baseRoutePathTeam}/edit`));
    } else {
      dispatch(push(`${baseRoutePath}/${type}/${id}/edit`));
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/admin/service-providers/store/actions.js